// @ts-nocheck
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useParams } from 'react-router'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'

import Document from 'js/components/Document'
import { NotFound } from 'js/core/NotFound'
import { featuredViewFragment } from 'js/lib/fragments/featured'

import VersionList from './components/VersionList'
import VersionPreview from './components/VersionPreview'
import styles from './VersionHistory.module.css'

const VersionHistory = () => {
    const { t } = useTranslation()

    const location = useLocation()

    const [refetchVersionHistory, setRefetchVersionHistory] = useState(
        location.state?.refetchTimeout || 0,
    )

    const params = useParams()
    const { guid, revisionGuid } = params

    const PAGE_SIZE = 50

    const { loading, data, refetch, fetchMore } = useQuery<any>(
        GET_VERSION_HISTORY,
        {
            variables: { guid, offset: 0, limit: PAGE_SIZE },
            fetchPolicy: 'cache-and-network',
        },
    )

    useEffect(() => {
        if (refetchVersionHistory > 0) {
            setTimeout(() => {
                refetch()
                setRefetchVersionHistory(0)
            }, refetchVersionHistory)
        }
    }, [refetch, refetchVersionHistory])

    if (loading) {
        return null
    }

    if (
        !data ||
        data?.revisions?.edges?.length === 0 ||
        (revisionGuid &&
            data?.revisions?.edges.findIndex(
                (el) => el.guid === revisionGuid,
            ) === -1)
    ) {
        return <NotFound />
    }

    const { site, entity, revisions } = data

    return (
        <div className={styles.wrapper}>
            <Document
                title={t('version.version-history')}
                containerTitle={entity?.title}
            />
            <VersionList
                entity={entity}
                revisions={revisions}
                className="VersionHistoryList"
                updating={refetchVersionHistory > 0}
                fetchMore={fetchMore}
            />
            <VersionPreview
                site={site}
                entity={
                    revisionGuid
                        ? revisions.edges.find((el) => el.guid === revisionGuid)
                              .content
                        : revisions.edges[0].content
                }
                className="VersionHistoryPreview"
            />
        </div>
    )
}

export const GET_VERSION_HISTORY = gql`
    query VersionHistory($guid: String!, $limit: Int = 10, $offset: Int = 0) {
        site {
            guid
            showTagsInDetail
            showCustomTagsInDetail
        }
        entity(guid: $guid) {
            guid
            ... on Blog {
                title
                url
            }
            ... on News {
                title
                url
            }
            ... on Wiki {
                title
                url
            }
            ... on Pad {
                title
                url
            }
            ... on Page {
                title
                url
            }
        }
        revisions(containerGuid: $guid, offset: $offset, limit: $limit) {
            total
            edges {
                guid
                authors {
                    guid
                    name
                    url
                }
                type
                container {
                    guid
                }
                description
                content {
                    title
                    richDescription
                    ${featuredViewFragment}
                    tagCategories {
                        name
                        values
                    }
                    tags
                }
                changedFields
                statusPublishedChanged
                timeCreated
            }
        }
    }
`

export default VersionHistory
